// iter136 — Phase 2 skeleton loaders. Cheap stand-in cards used while a
// page's primary data set is fetching, so the layout doesn't jump and the
// user sees an Android-style "shimmer" instead of a blank screen.
import { Skeleton } from "@/components/ui/skeleton";

export function CardSkeleton({ rows = 3, className = "" }) {
  return (
    <div className={`rounded-2xl border border-slate-200 bg-white p-4 shadow-sm ${className}`} data-testid="skeleton-card">
      <Skeleton className="h-4 w-1/3 bg-slate-200" />
      <Skeleton className="mt-3 h-3 w-2/3 bg-slate-100" />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} className="mt-2 h-3 w-full bg-slate-100" />
      ))}
    </div>
  );
}

export function ListSkeleton({ count = 4 }) {
  return (
    <div className="space-y-2" data-testid="skeleton-list">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3">
          <Skeleton className="h-9 w-9 rounded-lg bg-slate-200" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-3 w-3/4 bg-slate-200" />
            <Skeleton className="h-2 w-1/3 bg-slate-100" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="relative mb-4 overflow-hidden rounded-2xl bg-gradient-to-br from-slate-200 via-slate-100 to-slate-200 p-5 md:hidden" data-testid="skeleton-hero">
      <Skeleton className="h-3 w-20 bg-white/60" />
      <Skeleton className="mt-3 h-5 w-2/3 bg-white/80" />
      <Skeleton className="mt-2 h-3 w-1/3 bg-white/60" />
    </div>
  );
}
